import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import SelectedTags from "@/components/SearchComponent/UnbxdComponents/SelectedTags/SelectedTags";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import useIsMobile from "@hooks/useIsMobile";
import useFilterCache from "@/hooks/useFilterCache";

// Lazy loaded components with fallback
var fallback = {
  fallback: null
};
var YearsSelectedTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "Years-YearsSelectedTags-YearsSelectedTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "Years-YearsSelectedTags-YearsSelectedTags" */"../Years/YearsSelectedTags/YearsSelectedTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../Years/YearsSelectedTags/YearsSelectedTags");
    }
    return eval('require.resolve')("../Years/YearsSelectedTags/YearsSelectedTags");
  }
}, fallback);
var YearsTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "Years-YearsTags-YearsTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "Years-YearsTags-YearsTags" */"../Years/YearsTags/YearsTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../Years/YearsTags/YearsTags");
    }
    return eval('require.resolve')("../Years/YearsTags/YearsTags");
  }
}, fallback);
var CarCountriesTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "CarCountriesTags-CarCountriesTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "CarCountriesTags-CarCountriesTags" */"../CarCountriesTags/CarCountriesTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../CarCountriesTags/CarCountriesTags");
    }
    return eval('require.resolve')("../CarCountriesTags/CarCountriesTags");
  }
}, fallback);
var MakeModelYearTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "MakeModelYearTags-MakeModelYearTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "MakeModelYearTags-MakeModelYearTags" */"../MakeModelYearTags/MakeModelYearTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../MakeModelYearTags/MakeModelYearTags");
    }
    return eval('require.resolve')("../MakeModelYearTags/MakeModelYearTags");
  }
}, fallback);

/**
 * Component for displaying filter SEO chips with optimized loading and caching
 */
var UnbxdSEOChips = function UnbxdSEOChips() {
  // Get base data from hooks
  var _useFilterPage = useFilterPage(),
    loading = _useFilterPage.isLoading,
    isAutosPage = _useFilterPage.isAutosPage,
    isYearsPage = _useFilterPage.isYearsPage;
  var isMobile = useIsMobile();
  var _useSearchResultsData = useSearchResultsData(),
    filters = _useSearchResultsData.filters,
    selectedOptions = _useSearchResultsData.selectedOptions,
    metaData = _useSearchResultsData.metaData;

  // Use filter cache hook to optimize UI during navigation
  var _useFilterCache = useFilterCache(loading, filters, selectedOptions),
    effectiveFilters = _useFilterCache.effectiveFilters,
    effectiveOptions = _useFilterCache.effectiveOptions,
    shouldShowShimmer = _useFilterCache.shouldShowShimmer;

  // Determine if yearsTags should be shown
  var showYearsTags = isYearsPage && effectiveFilters.length > 4 || isAutosPage && effectiveFilters.length > 4 && !effectiveOptions.length;

  // Render the tags conditionally with optimized loading states
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAutosPage && effectiveOptions.length && effectiveFilters.length > 4 ? shouldShowShimmer ? /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-selected-loading",
    className: "selected-tags-wrapper flex gap-2 pt-6 pr-5 pb-4 pl-5 border-solid border-b border-[#e1e8f2]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!m-0",
    numberOfLoaders: 5,
    divHeight: "34.99px",
    divWidth: "66.68px"
  })) : /*#__PURE__*/React.createElement(SelectedTags, {
    className: "m-hide",
    tags: effectiveOptions
  }) : null, isAutosPage && effectiveFilters.length > 4 ? shouldShowShimmer ? /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-makemodelyear-loading",
    className: "pt-4 pr-5 pb-6 pl-5 border-solid border-b border-[#e1e8f2]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!mb-[12px]",
    numberOfLoaders: 1,
    divHeight: "24px",
    divWidth: "60px"
  }), /*#__PURE__*/React.createElement("div", {
    className: " flex gap-2 px-[8px]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!m-0 ",
    numberOfLoaders: 5,
    divHeight: "31.99px",
    divWidth: "53.3px"
  }))) : /*#__PURE__*/React.createElement(MakeModelYearTags, {
    className: "m-hide",
    selectedOptions: effectiveOptions,
    filters: effectiveFilters,
    metaData: metaData
  }) : null, isYearsPage && effectiveOptions.length && effectiveFilters.length > 4 ? shouldShowShimmer ? /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-years-selected-loading",
    className: "pt-4 pr-5 pb-6 pl-5 border-solid border-b border-[#e1e8f2]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!mb-[12px]",
    numberOfLoaders: 1,
    divHeight: "24px",
    divWidth: "60px"
  }), /*#__PURE__*/React.createElement("div", {
    className: " flex gap-2 px-[8px]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!m-0 ",
    numberOfLoaders: 5,
    divHeight: "31.99px",
    divWidth: "53.3px"
  }))) : /*#__PURE__*/React.createElement(YearsSelectedTags, {
    className: "m-hide",
    tags: effectiveOptions
  }) : null, showYearsTags && (shouldShowShimmer ? /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-years-loading",
    className: "pt-4 pr-5 pb-6 pl-5 border-solid border-b border-[#e1e8f2]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!mb-[12px]",
    numberOfLoaders: 1,
    divHeight: "24px",
    divWidth: "60px"
  }), /*#__PURE__*/React.createElement("div", {
    className: " flex gap-2 px-[8px]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!m-0 ",
    numberOfLoaders: 5,
    divHeight: "31.99px",
    divWidth: "53.3px"
  }))) : /*#__PURE__*/React.createElement(YearsTags, {
    className: "m-hide",
    selectedOptions: effectiveOptions,
    filters: effectiveFilters,
    metaData: metaData
  })), showYearsTags && (shouldShowShimmer ? /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-countries-loading",
    className: "pt-4 pr-5 pb-6 pl-5 border-solid border-b border-[#e1e8f2]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!mb-[12px]",
    numberOfLoaders: 1,
    divHeight: "24px",
    divWidth: "60px"
  }), /*#__PURE__*/React.createElement("div", {
    className: " flex gap-2 px-[8px]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "!m-0 ",
    numberOfLoaders: 5,
    divHeight: "31.99px",
    divWidth: "53.3px"
  }))) : /*#__PURE__*/React.createElement(CarCountriesTags, {
    className: "m-hide",
    filters: effectiveFilters
  })));
};
export default UnbxdSEOChips;